<template>
  <div class="header-user-icon">
    <ul>
      <li v-if="dele" @click="Action('dele', to, id, formId)">
        <img src="@/assets/img/new/user/dele.png" />
        <p>删除</p>
      </li>
      <li v-if="edit" @click="Action('edit', to, id, formId)">
        <img src="@/assets/img/new/user/edit.png" />
        <p>编辑</p>
      </li>
      <li v-if="add" @click="Action('add', to, id, formId)">
        <img src="@/assets/img/new/user/add.png" />
        <p>添加</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "headerIcon",
  props: {
    dele: {
      type: Boolean,
      default: false
    },
    add: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    Action: {
      type: Function
    },
    to: {
      type: String,
      default: ""
    },
    id: {
      type: Number
    },
    formId: {
      type: Number
    }
  }
};
</script>
<style scoped>
.header-user-icon ul {
  display: flex;
  align-items: center;
}
.header-user-icon li {
  display: flex;
  align-items: center;
}
.header-user-icon li {
  font-size: 16px;
  font-weight: 400;
  color: #99c1ff;
  margin-left: 6px;
  cursor: pointer;
  margin-left: 20px;
}
.header-user-icon li img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 5px;
}
.header-user-icon li p {
  font-size: 16px;
  font-weight: 400;
  color: #99c1ff;
  line-height: 24px;
}
</style>
